// extracted by mini-css-extract-plugin
export default {"container":"pablisher-image_container__4J5UT","image_wrapper":"pablisher-image_image_wrapper__sNlsZ"};